import 'meta/extensions/jquery';
import 'webpack-jquery-ui/draggable';
import './style.less';
import { setDataGlobal } from 'meta/features/json-params';
import { setupUserActivityChecking } from 'meta/features/user-activity';
import { addScript, evalScript } from 'meta/features/add-script';
import WebEvents from 'meta/features/web-events';
import VirtualPath from 'meta/utils/virtualPath';
import { getRootApi } from 'meta/utils/getRootApi';
import { getFormConfiguration } from './features/formDialogBuilder';
import { Dialog } from './features/Dialog';
import 'meta/extensions/icons';
function setupWebEvents(iframeWindow) {
    const handleWebEvent = function (event) {
        getRootApi().FrontendEvents.webEvent(event, iframeWindow.name);
    };
    // run on sync postback
    WebEvents.run(iframeWindow, handleWebEvent);
    // run on async postback
    if (iframeWindow.Sys && iframeWindow.Sys.Application) {
        iframeWindow.Sys.Application.add_load(function () {
            WebEvents.run(iframeWindow, handleWebEvent);
        });
    }
}
function confirm(title, message, callback, options) {
    let cb = callback
        ? callback
        : function () { };
    return Dialog.show(Object.assign({
        title,
        hideCloseButton: true,
        body: message,
        buttons: {
            OK: {
                label: 'OK',
                type: 'success',
                focus: true,
                callback: () => {
                    cb(true);
                    return true;
                }
            },
            CANCEL: {
                label: 'Cancel',
                type: 'danger',
                focus: true,
                keyCode: 27,
                callback: () => {
                    cb(false);
                    return false;
                }
            }
        }
    }, options));
}
function alert(title, message, callback) {
    let cb = callback
        ? callback
        : function () { };
    return Dialog.show({
        title,
        hideCloseButton: true,
        body: message,
        buttons: {
            OK: {
                label: 'OK',
                type: 'success',
                keyCode: 27,
                callback: () => {
                    cb(true);
                }
            }
        }
    });
}
function getCurrent() {
    return Dialog.current;
}
function getModals() {
    return Dialog.modals;
}
function getTargetDocument() {
    return Dialog.targetDocument;
}
function showIframe(title, url, frameSessionId, width, height, onHide) {
    if (!url.startsWith(`${VirtualPath}/`))
        url = `${VirtualPath}/${url}`;
    const iframeName = `modal_frame_${Date.now()}`;
    let promise = Dialog.show({
        title,
        body: `<iframe name="${iframeName}" src="${url}${url.indexOf('?') != -1 ? '&' : '?'}iframeMode=true&frameSession=${frameSessionId}" />`,
        className: 'iframe-modal',
        width,
        height,
        onHide,
        iframeName
    });
    // support for close window api same as with deprecated showModalWindow
    const iframe = promise.modal?.modal?.querySelector('iframe');
    const iframeWin = iframe?.contentWindow;
    if (iframe !== null && iframe !== undefined && iframeWin !== null) {
        iframeWin.modal = promise.modal;
        iframe.addEventListener('load', function () {
            const iframeWin = iframe.contentWindow;
            if (iframeWin !== null) {
                iframeWin.modal = promise.modal;
                iframeWin.frameSession = frameSessionId ?? undefined;
                setDataGlobal(iframeWin);
                setupUserActivityChecking(iframeWin);
                setupWebEvents(iframeWin);
                // dynamically add script
                if (!iframeWin.modules || !iframeWin.modules.init) {
                    // if init not present, include it and then run the hotkeys script
                    addScript('@init', iframeWin).then(() => {
                        evalScript(`
                                Hotkeys.bindHere({
                                    "esc": function() {
                                        modal.hide()
                                    }
                                }, true);
                            `, iframeWin);
                    });
                }
                else {
                    // otherwise just run the hotkeys script
                    evalScript(`
                            Hotkeys.bindHere({
                                "esc": function() {
                                    modal.hide()
                                }
                            }, true);
                        `, iframeWin);
                }
            }
        });
    }
    return promise;
}
function windowOpen(urlPromise, w = 480, h = 320) {
    let left = (screen.width / 2) - (w / 2);
    let top = (screen.height / 2) - (h / 2);
    // browser popup hack, first we set only plain url. Than we change it to proper one
    const win = window.open('', '_blank', 'toolbar=no, location=no, directories=no, resizable=yes, status=no, menubar=no, scrollbars=yes, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    if (win !== null) {
        win.document.write(`
            <style>
            * { font-family: Tahoma; }
            h4 { margin: auto; }
            </style>
            <h4>Loading ...</h4>
        `);
        // after window is open, we call the callback to give programmer a chance to change
        if (typeof (urlPromise) === "function") {
            urlPromise((url) => {
                win.location.href = url;
            });
        }
        else {
            win.location.href = urlPromise;
        }
        let promise = new Promise((resolve, reject) => {
            setInterval(() => {
                if (win.closed)
                    resolve();
            }, 1000);
        });
        let windowPromise = Object.assign(promise, { window: win });
        return windowPromise;
    }
    else {
        throw new Error("Failed to open new window");
    }
}
function setupDocument(document) {
    Dialog.targetDocument = document;
}
function showForm(title, fields, opts) {
    return new Promise(function (resolve, reject) {
        if ("then" in fields) {
            let d = Dialog.show({
                title: 'Loading ...',
                body: `Loading ${title} ...`,
                hideCloseButton: true
            });
            fields.then((fieldsData) => {
                d.modal?.hide();
                if (fieldsData.length > 0) {
                    Dialog.show(getFormConfiguration(title, fieldsData, opts)).then(resolve);
                }
                else {
                    resolve({});
                }
            });
        }
        else {
            Dialog.show(getFormConfiguration(title, fields, opts)).then(resolve);
        }
    });
}
export default {
    showForm,
    setupDocument,
    show: Dialog.show,
    showIframe,
    getCurrent,
    getModals,
    getTargetDocument,
    confirm,
    alert,
    windowOpen
};
